define.alias("checkout/components/charges-summary", "settings/components/charges-summary");